import {
  SearchRowAutoPayStrategy,
  SearchRowEngagementStatusRollup,
  SearchRowTinStatus
} from "@wingspanhq/wingspan-api-sdk";
import { FiltersValueBase } from "../../../../../shared/hooks/useUrlQueryFilters";

export enum PayeeFilterShareTaxDocument {
  Shared = "Shared",
  NotShared = "NotShared"
}

export enum PayeeFilterEligibilityStatus {
  All = "All",
  Complete = "Complete",
  Incomplete = "Incomplete",
  SpecificRequirement = "SpecificRequirement"
}

export enum PayeeFilterRequirementStatus {
  All = "All",

  // Requirement type specific filters
  AwaitingContractorSignature = "AwaitingContractorSignature",
  AwaitingClientSignature = "AwaitingClientSignature",
  PendingBackgroundCheck = "PendingBackgroundCheck",
  ProcessingBackgroundCheck = "ProcessingBackgroundCheck",
  FailedBackgroundCheck = "FailedBackgroundCheck",

  // Requirement status
  Incomplete = "Incomplete",
  Complete = "Complete",

  // Review status
  PendingApproval = "PendingApproval",
  Rejected = "Rejected",
  Approved = "Approved",

  // Expiration
  Expired = "Expired",
  Expiring = "Expiring"
}

export interface PayeeFilters extends FiltersValueBase {
  // Support this because for tabs
  searchableStatus?: SearchRowEngagementStatusRollup;
  eligibilityStatus?: PayeeFilterEligibilityStatus;
  requirementStatus?: PayeeFilterRequirementStatus;
  requirementDefinitionId?: string;
  requirementDefinitionVersion?: string;
  searchableTinStatus?: SearchRowTinStatus[];
  shareTaxDocument?: PayeeFilterShareTaxDocument[];
  payerId?: string[];
  engagementId?: string;
  autoPayStrategy?: SearchRowAutoPayStrategy[];
  bulkBatchId?: string;
}
